import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ForgotComponent } from './containers/login/forgot/forgot.component'
import { LoginComponent } from './containers/login/login.component'
import { ResetComponent } from './containers/login/reset/reset.component'
import { SetupComponent } from './containers/login/setup/setup.component'
import { SigninComponent } from './containers/login/signin/signin.component'
import { LayoutComponent } from './components/layout/layout.component'

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'login',
        component: SigninComponent
      },
      {
        path: 'forgot',
        component: ForgotComponent
      },
      {
        path: 'setup',
        component: SetupComponent
      },
      {
        path: 'reset/:token',
        component: ResetComponent
      }
    ]
  },
  {
		path: 'refund-request',
		loadChildren: () => import('./containers/refund.exception/refund.exception.module').then(m => m.RefundExceptionModule)
	},
  {
    path: 'scanner',
    loadChildren: () => import('./containers/scanner/scanner.module').then(m => m.ScannerModule),
    data: {
      fullScreen: true
    }
  },
  {
    path: 'review',
    loadChildren: () => import('./containers/review/review.module').then(m => m.ReviewModule),
    data: {
      fullScreen: true
    }
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'order',
        loadChildren: () => import('./containers/order/order-routing.module').then(m => m.OrderRoutingModule)
      },
      {
        path: '',
        loadChildren: () => import('./containers/home/home-routing.module').then(m => m.HomeRoutingModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      paramsInheritanceStrategy: 'always'
    }
  )],
  exports: [RouterModule]
})

export class AppRoutingModule { }
